module.exports = __webpack_public_path__ + "static/media/jingqingqidai.ac4dcfae.png";